interface anyType {
  [key: string]: string | object
}

function type(obj: unknown) {
  return typeof obj !== 'object' ? typeof obj : Object.prototype.toString.call(obj).slice(8, -1).toLowerCase()
}

const urlExt = {
  queryToJson: (urlParam?: string, shouldDecodeParam?: boolean) => {
    const url = String(urlParam || window.location.href.replace(window.location.hash, ''))
    const shouldDecode = typeof shouldDecodeParam === 'boolean' ? shouldDecodeParam : true

    const qJson: Record<string, string> = {}
    const qList = url.substr(url.lastIndexOf('?') + 1).split('&')

    function getQueryValue(val: string): string {
      let dealVal = val

      if (shouldDecode) {
        try {
          dealVal = decodeURIComponent(val)
        } catch (ex) {
          console.log(ex)
        }
      }

      return dealVal
    }

    for (let i = 0; i < qList.length; ++i) {
      if (qList[i]) {
        const myQuery = qList[i].split('=')
        if (myQuery.length > 1) {
          const myKey = myQuery[0]
          const dealVal = myQuery[1]
          qJson[myKey] = getQueryValue(dealVal)
        }
      }
    }
    return qJson
  },
  jsonToQuery: (json: anyType, shouldEncodeParam?: boolean) => {
    const shouldEncode = typeof shouldEncodeParam === 'boolean' ? shouldEncodeParam : true

    function getQuery(key: string, val: any): string | undefined | any[] {
      let myQuery

      switch (type(val)) {
        case 'boolean':
        case 'number':
        case 'string':
          myQuery = `${key}=${shouldEncode ? encodeURIComponent(val) : val}`
          break
        case 'regexp':
          myQuery = `${key}=${shouldEncode ? encodeURIComponent(val.source) : val.source}`
          break
        case 'date':
          myQuery = `${key}=${val.getTime}`
          break
        case 'array':
          myQuery = []
          for (let i = 0; i < val.length; ++i) {
            if (/^boolean|number|string|regexp|date$/.test(typeof val[i])) {
              myQuery.push(getQuery(key, val[i]))
            }
          }
          break
        default:
          myQuery = undefined
      }
      return myQuery
    }

    let queries: string[] = []
    if (type(json) === 'object') {
      const keys = Object.keys(json)
      keys.map((key) => {
        const query = getQuery(key, json[key])
        if (query) {
          queries = queries.concat(query)
        }
        return true
      })
    }

    return queries.join('&')
  },
  getQuery: (qName: string, url: string) => {
    const myName = qName ? String(qName) : ''
    const myUrl = url || window.location.href.replace(window.location.hash, '')

    let curQueries = urlExt.queryToJson(myUrl)
    curQueries = !Object.keys(curQueries).length ? {} : curQueries
    const res = myName ? curQueries[myName] || '' : curQueries
    return res
  },
  setQuery: (qNameOrQueries: string | number | anyType, qValueOrUrl: string, urlparam: string) => {
    let newQuery = ''

    if (qNameOrQueries) {
      let queries: anyType = {}
      let hash = ''
      let url = ''

      switch (type(qNameOrQueries)) {
        case 'string':
        case 'number':
          url = urlparam || window.location.href
          queries[qNameOrQueries as string | number] = qValueOrUrl
          break
        case 'object':
          url = qValueOrUrl || window.location.href
          queries = qNameOrQueries as anyType
          break
        default:
      }

      if (/(#.+)$/i.test(url)) {
        hash = RegExp.$1
        url = url.replace(hash, '')
      }
      const curQueries = urlExt.queryToJson(url)

      Object.assign(curQueries, queries)
      Object.keys(queries).map((key) => {
        if (queries[key] === undefined) {
          delete curQueries[key]
        }
        return true
      })

      newQuery = urlExt.jsonToQuery(curQueries) + hash
    }

    return newQuery
  },
}

export const urlJson = urlExt.queryToJson()

export default urlExt
